












import {
  defineComponent
} from '@nuxtjs/composition-api';
import FilterableProductsLayout from 'components/catalog/FilterableProductsLayout.vue';

export default defineComponent({
  name: 'SearchPage',
  components: {
    FilterableProductsLayout
  }
})
